// import { useLocation } from "react-router-dom";
// import SEO from "./SEO";
// import { pageMetadata } from "./pageMetadata";
// import apiClient from "./apiClient";
// import { useEffect, useState } from "react";

// const RouteSEO = ({ children }) => {
//   const location = useLocation();
//   const path = location.pathname;

//   const [articleMeta, setArticleMeta] = useState(null);
//   const [loading, setLoading] = useState(false);
//   // Map routes to metadata keys
//   const routeToMetadataKey = {
//     "/": "home",
//     "/docs": "academy",
//     "/academy": "academy",
//     "/pricing": "pricing",
//     "/contactsales": "contactSales",
//     "/contact": "contact",
//     "/contactsupport": "contactSupport",
//     "/login": "login",
//     "/about": "about",
//     "/careers": "careers",
//     "/changelog": "changelog",
//     "/publiclog": "changelog",
//     "/brand": "brand",
//     "/security": "security",
//     "/features": "features",
//     "/features/team-workflow": "/features/team-workflow",
//     "/features/custom-dashboard": "/features/custom-dashboard",
//     "/features/smart-scheduling": "features/smart-scheduling",
//     "/features/document-management": "features/document-management",
//     "/features/task-management": "/features/task-management",
//     "/office-hub": "officeHub",
//     "/partners": "partners",
//     "/partnerform": "partners",
//     "/terms": "terms",
//     "/privacy-policy": "privacy",
//     "/policy-refund": "refund",
//     "/waitlist": "waitlist",
//     "/bulkActionsCoherent": "features",
//     "/features/instant-messaging": "features",
//     "/Admin_Docs": "academy",
//   };

//   // Handle dynamic routes
//   let metadataKey = routeToMetadataKey[path];

//   // Handle career details page
//   if (path.startsWith("/careers/") && path !== "/careers") {
//     metadataKey = "careers";
//   }

//   const isDocsArticle = path.includes("/docs");

//   useEffect(() => {
//     if (!isDocsArticle) {
//       setArticleMeta(null);
//       return;
//     }

//     const slug = path.replace("/docs", "");
//     setLoading(true);

//     const ShareArticleData = async () => {
//       try {
//         // const res = await apiClient.get("/help-center/category-groups");
//         const ShareArticle = await apiClient.get(
//           "/help-center/category-groups",
//         );
//         const page = ShareArticle.data?.data;

//         const PageMap = page.flatMap((group) =>
//           group.categories.map((cat) => ({
//             groupId: group.id,
//             categoryId: cat.id,
//             name: cat.name,
//             slug: cat.slug,
//           })),
//         );
//         console.log("Share Article 1", PageMap, page);
//         const ddd = {
//           name: PageMap.map((item) => item.name),
//           head: page.map((item) =>
//             item.categories.map((itemm) =>
//               itemm.pages.map((itemmm) => itemmm.heading),
//             ),
//           ),
//           title: page.map((item) =>
//             item.categories.map((itemm) =>
//               itemm.pages.map((itemmm) => itemmm.title),
//             ),
//           ),
//         };
//         console.log("Share Article 2", ddd);
//         console.log("Share Article 0", page);
//       } catch (e) {
//         console.log("Error", e);
//       } finally {
//         setLoading(false);
//       }
//     };
//     ShareArticleData();
//   }, []);
//   // Handle docs detail page
//   // if (path.startsWith("/docs/") && path !== "/docs") {
//   //   metadataKey = "academy";
//   // }

//   const metadata = pageMetadata[metadataKey] || pageMetadata.home;

//   return (
//     <>
//       <SEO
//         title={metadata.title}
//         description={metadata.description}
//         image={metadata.image}
//         url={`https://simplifyte.com${path}`}
//       />
//       {children}
//     </>
//   );
// };

// export default RouteSEO;

import { useLocation } from "react-router-dom";
import SEO from "./SEO";
import { pageMetadata } from "./pageMetadata";
import apiClient from "./apiClient";
import { useEffect, useState } from "react";

const RouteSEO = ({ children }) => {
  const location = useLocation();
  const path = location.pathname;

  const [articleMeta, setArticleMeta] = useState(null);
  const [loading, setLoading] = useState(false);

  // Static route metadata mapping (unchanged)
  const routeToMetadataKey = {
    "/": "home",
    "/docs": "academy",
    "/academy": "academy",
    "/pricing": "pricing",
    "/contact": "contact",
    "/contactsales": "contactSales",
    "/contactsupport": "contactSupport",
    "/login": "login",
    "/about": "about",
    "/careers": "careers",
    "/changelog": "changelog",
    "/publiclog": "changelog",
    "/brand": "brand",
    "/security": "security",
    "/features": "features",
    "/features/team-workflow": "teamWorkflow",
    "/features/custom-dashboard": "customDashboard",
    "/features/smart-scheduling": "smartScheduling",
    "/features/document-management": "documentsOrganized",
    "/features/task-management": "taskManagement",
    "/office-hub": "officeHub",
    "/bulkActionsCoherent": "bulkActions",
    "/partners": "partners",
    "/partnerform": "partners",
    "/terms": "terms",
    "/privacy-policy": "privacy",
    "/policy-refund": "refund",
    "/waitlist": "waitlist",
    "/features/instant-messaging": "features",
    "/Admin_Docs": "academy",
    "/ca-firms": "caFirms",
    "/legal-teams": "legalTeams",
    "/it-services": "itServices",
    "/solutions/ca-firms": "solutionsCaFirms",
    "/solutions/tax-consultants": "solutionsTaxConsultants",
    "/solutions/advocates": "solutionsAdvocates",
    "/solutions/professional-services": "solutionsProfessionalServices",
    "/features/client-wise-work-tracking": "featureClientWise",
    "/features/fy-period-tracking": "featureFYTracking",
    "/features/document-collection": "featureDocumentCollection",
    "/features/review-approval-workflow": "featureReviewApproval",
    "/features/deadline-reminders": "featureDeadlineReminders",
    "/features/closure-proof": "featureClosureProof",
    "/features/audit-trail": "featureAuditTrail",
    "/features/mcp-integration": "featureMcpIntegration",
    "/compare/excel-vs-simplifyte": "compareExcel",
    "/compare/whatsapp-vs-simplifyte": "compareWhatsApp",
    "/compare/generic-task-tools-vs-simplifyte": "compareGenericTools",
    "/ca-community": "caCommunity",
  };

  const noindexPaths = ["/Admin_Docs", "/bulkActionsCoherent"];

  let metadataKey = routeToMetadataKey[path];
  if (path.startsWith("/careers/") && path !== "/careers") {
    metadataKey = "careers";
  }

  const isDocsArticle = path.includes("/docs") && path !== "/docs";

  // Fetch help center data only for documentation articles
  useEffect(() => {
    if (!isDocsArticle) {
      setArticleMeta(null);
      return;
    }

    const slugFromPath = path.replace("/docs", ""); // e.g. "/60-second-setup"
    setLoading(true);

    const fetchArticleData = async () => {
      try {
        const response = await apiClient.get("/help-center/category-groups");
        const groups = response.data?.data || [];
        // console.log("first", groups);
        // Build a map: page slug -> { categoryName, pageTitle, pageHeading, description }
        const pageMap = new Map();

        for (const group of groups) {
          const groupCategories = group.categories || [];
          for (const category of groupCategories) {
            const pages = category.pages || [];
            for (const page of pages) {
              if (page.slug) {
                pageMap.set(page.slug, {
                  categoryName: category.name,
                  pageTitle: page.title,
                  pageHeading: page.heading,
                  description: page.description, // stringified rich content
                });
              }
            }
          }
        }

        // Remove leading slash if any
        const cleanSlug = slugFromPath.startsWith("/")
          ? slugFromPath.slice(1)
          : slugFromPath;
        const matchedPage = pageMap.get(cleanSlug);

        if (matchedPage) {
          // Extract plain text from description JSON for meta description
          let plainDescription = "";
          if (matchedPage.description) {
            try {
              const blocks = JSON.parse(matchedPage.description);
              // Find first paragraph or heading text
              const textBlocks = blocks.filter(
                (block) =>
                  block.type === "paragraph" || block.type === "heading",
              );
              for (const block of textBlocks) {
                if (block.content && block.content.length) {
                  const text = block.content.map((item) => item.text).join(" ");
                  if (text.trim()) {
                    plainDescription = text.slice(0, 160);
                    break;
                  }
                }
              }
            } catch (e) {
              console.warn("Failed to parse description JSON", e);
            }
          }

          setArticleMeta({
            title: `${matchedPage.categoryName} | ${matchedPage.pageTitle}`,
            description:
              matchedPage.pageHeading ||
              `Learn how to ${matchedPage.pageHeading?.toLowerCase()} – step‑by‑step guide.`,
          });
        } else {
          // Fallback to default academy metadata
          setArticleMeta(null);
        }
      } catch (error) {
        console.error("Error fetching help center data:", error);
        setArticleMeta(null);
      } finally {
        setLoading(false);
      }
    };

    fetchArticleData();
  }, [path]);

  // Decide final metadata (article overrides static if available)
  let finalMetadata;
  // console.log("3232 00", isDocsArticle && articleMeta);
  if (isDocsArticle && articleMeta) {
    finalMetadata = {
      title: articleMeta.title,
      description: articleMeta.description,
      image: pageMetadata.academy?.image || "/default-og-image.png",
    };
  } else {
    const metadata = pageMetadata[metadataKey] || pageMetadata.home;
    finalMetadata = {
      title: metadata.title,
      description: metadata.description,
      image: metadata.image,
    };
  }

  // Optional: show loading state inside SEO component? Usually we just wait.
  if (loading && isDocsArticle) {
    // You can return a skeleton or just keep rendering with previous metadata
    // For simplicity, we'll still render with fallback (prevents flicker)
  }
  // console.log("3232 11", finalMetadata);
  return (
    <>
      <SEO
        title={finalMetadata.title}
        description={finalMetadata.description}
        image={finalMetadata.image}
        url={`https://www.simplifyte.com${path}`}
        noindex={noindexPaths.includes(path)}
      />
      {children}
    </>
  );
};

export default RouteSEO;
